import React from 'react';
import { Sparkles } from 'lucide-react';
import { AssistantRuntimeProvider, Tools, useAui } from '@assistant-ui/react';
import { Thread } from '@/Components/ai-ui/thread';
import useAnthropicManagedAgentRuntime from '../ai-ui/AnthropicManagedAgentRuntimeProvider';
import { useAnthropicManagedAgentSession } from '../store/AnthropicManagedAgentSessionContext';
import tmMCPToolkit from '../ai-ui/TMMCPTookit';

const AgentChatWindow = () => {
    const runtime = useAnthropicManagedAgentRuntime();
    const { sessionStatus } = useAnthropicManagedAgentSession();
    const isInputDisabled = sessionStatus === 'terminated';

    const aui = useAui({
        tools: Tools({ toolkit: tmMCPToolkit }),
    });

    return (
        <AssistantRuntimeProvider aui={aui} runtime={runtime}>
            <div className="flex min-h-0 flex-1 flex-col">
                <div className="flex shrink-0 items-center gap-2 border-b bg-white px-4 py-2.5">
                    <div className="bg-primary/10 flex size-7 items-center justify-center rounded-full">
                        <Sparkles className="text-primary size-4" />
                    </div>
                    <span className="text-sm font-semibold">AI Search Agent</span>
                </div>

                <div className="min-h-0 flex-1 overflow-hidden">
                    <Thread disableInput={isInputDisabled} />
                </div>
            </div>
        </AssistantRuntimeProvider>
    );
};

export default AgentChatWindow;
